import { Component, h } from '@stencil/core';

@Component({
  tag: 'color-preview',
  styleUrl: 'color-preview.css',
  shadow: false, // Change this from true to false
  scoped: true  // Add this line
})
export class ColorPreview {
  private renderColorBox(varName: string, textVarName?: string) {
    return (
      <div class="color-box" style={{ backgroundColor: `var(${varName})`, color: textVarName ? `var(${textVarName})` : '#000' }}>
        {varName}
      </div>
    );
  }

  private renderColorSection(title: string, prefix: string, includeContrast = true) {
    return (
      <div class="color-section">
        <unity-typography variant="h4">{title}</unity-typography>
        <div class="color-grid">
          {this.renderColorBox(`--${prefix}-color`, includeContrast ? `--${prefix}-contrast-text` : undefined)}
          {this.renderColorBox(`--${prefix}-color-dark`, includeContrast ? `--${prefix}-contrast-text` : undefined)}
          {this.renderColorBox(`--${prefix}-color-light`, includeContrast ? `--${prefix}-contrast-text` : undefined)}
          {this.renderColorBox(`--${prefix}-color-hint`, includeContrast ? `--${prefix}-contrast-text` : undefined)}
        </div>
      </div>
    );
  }

  private renderStatusSection(title: string, prefix: string) {
    return (
      <div class="color-section">
        <unity-typography variant="h4">{title}</unity-typography>
        <div class="color-grid">
          {this.renderColorBox(`--${prefix}-color-main`, `--${prefix}-contrast-text`)}
          {this.renderColorBox(`--${prefix}-color-dark`, `--${prefix}-contrast-text`)}
          {this.renderColorBox(`--${prefix}-color-light`, `--${prefix}-contrast-text`)}
          {this.renderColorBox(`--${prefix}-color-hint`, `--${prefix}-contrast-text`)}
        </div>
      </div>
    );
  }

  render() {
    return (
      <div class="container">
        <unity-typography variant="h2">Unity Theme</unity-typography>
        <div class="theme-section">
          <div class="unity-theme">
            {this.renderColorSection('Primary Colors', 'primary')}
            {this.renderColorSection('Secondary Colors', 'secondary')}
          </div>
        </div>

        <unity-typography variant="h2">SAP Theme</unity-typography>
        <div class="theme-section">
          <div class="sap-theme">
            {this.renderColorSection('Primary Colors', 'primary')}
            {this.renderColorSection('Secondary Colors', 'secondary')}
          </div>
        </div>

        <unity-typography variant="h2">Status Colors</unity-typography>
        <div class="status-section">
          {this.renderStatusSection('Success', 'success')}
          {this.renderStatusSection('Error', 'error')}
          {this.renderStatusSection('Warning', 'warning')}
          {this.renderStatusSection('Info', 'info')}
          {this.renderStatusSection('Note', 'note')}
        </div>
      </div>
    );
  }
}